<template>
    <div class="code_item" v-if="isShowRecord">
        <span class="label" :style="styleString" v-if="hasWorkCode">{{ workCodetitle }}</span>
        <span class="label white_line" :style="styleString" v-if="!hasWorkCode">{{ workCodetitle }}</span>
        <div class="staff_wrap">
            <span class="staff" v-for="(user, index) in employees" :key=index>{{ user?.title }}</span>
        </div>
    </div>
</template>


<script>
import { sheetState } from '../../../../../../sheet-state'
import { workerState } from '../../../worker-state'
import { useManagingWorkers } from '@/composables/use-managing-workers'

const moment = require('@/util/MPMoment')

export default {
    setup() {
        const { employees: allEmployees } = useManagingWorkers()
        return { allEmployees }
    },
    props: {
        record: Object
    },
    data() {
        return {
            sheetState,
            worker: workerState,
        }
    },
    computed: {
        isShowRecord: function() {
            if (this.record.isCustomized == true && this.isSelected == true) {
                if (this.isAllUnselected == true) {
                    return this.hasEmployees == true
                }
            }
            return this.isSelected == true && this.hasEmployees == true            
        },
        isSelected: function() {
            if (this.record.isCustomized == true) {
                return this.worker.isShowCustomTimeCode
            }
            else {
                if (this.isAllUnselected == true) { return true }
                return this.workCodes?.find(c => c._id == this.record.workCodeID._id)?.isSelected
            }
        },
        isAllUnselected: function() {
            let notCustomizedRecords = this.workCodes?.filter(c => c.isCustomized != true)
            let selectedOne = notCustomizedRecords.find(c => c.isSelected == true)
            if (selectedOne == undefined) { return true }
            return false
        },
        hasEmployees: function() { return this.employees?.length != 0 },
        workCodes: function() { return this.worker.workCodes },
        workCode: function() { return this.record.workCodeID ?? {} },
        hasWorkCode: function() { return this.workCode._id != undefined },
        reservationSetting: function() { return this.sheetState.reservationSetting },
        palette: function() { return this.reservationSetting?.workCodeColorPaletteID?.basicPalette },
        paletteIndex: function() { return this.workCode.paletteIndex },
        hasCustomPalette: function() { return this.workCode.usingCustomColor ?? false },
        textColor: function() {
            if (this.backgroundColor == '#FFF') { return '#000'}
            let color = this.backgroundColor.slice(1)
            let rgb = parseInt(color, 16) // 16진수를 10진수로 변환
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff
            let brightness = 0.299 * r + 0.587 * g + 0.114 * b
            if (brightness > 111) { return '#000' }
            return '#FFF'
        },
        backgroundColor: function() {
            if (this.hasCustomPalette == true) { return this.workCode.customColorCode }
            if (this.hasWorkCode == false) { return '#FFF' }
            return this.palette[this.paletteIndex]
        },
        styleString: function() {
            return 'background-color: ' + this.backgroundColor + '; ' + 'color: ' + this.textColor + ';'
        },
        workCodetitle: function() {
            if (this.hasWorkCode) { return this.workCode.title }
            let start = moment(this.record.startedAt)
            let end = moment(this.record.endedAt)
            return start.format('HH:mm') + '~' + end.format('HH:mm')
        },
        selectedEmployees: function() {
            return this.allEmployees.filter(e => e.isSelected)
        },
        employees: function() { 
            let origin = this.selectedEmployees.map(e => e._id)
            let employees = this.record.employees
            employees = employees.filter(e => origin.includes(e._id) == true)
            return employees
        },

    }
}
</script>

<style scoped>
    .v2_rsv .schedule .schedule_calendar_wrap .day_wrap .code_item .label.white_line{
        min-width: 80px;
    }
</style>